import React from 'react';
import Navbar from "./Navbar";
import Hero from './Hero';
import WhyUs from './WhyUs';
import Contact from './Contact';
import Footer from './Footer';
import Modul from './Modul';
import strkopiesky from '../resources/strkopiesky.jpg';
import piesok from '../resources/piesok.jpg';
import kamen from '../resources/Kamenivo 8-16.jpeg';
import dekorativne from '../resources/dekorativne.jpg';
import { Link, ScrollRestoration } from 'react-router-dom';
import AnimateOnScroll from './AnimateOnScroll';
import 'animate.css';

const items = [
  {
    img: strkopiesky,
    title: 'ŠTRKOPIESKY',
    description: 'Štrkopiesok je používaný v stavebníctve pre výrobu betónu a základových vrstiev. Ideálna voľba pre rôzne stavebné projekty.',
    link: '/ponuka/strkopiesky',
  },
  {
    img: kamen,
    title: 'KAMENIVO',
    description: 'Kamenivo je základným stavebným materiálom, využívaným na vytváranie pevných a stabilných konštrukcií.',
    link: '/ponuka/kamenivo',
  },
  {
    img: piesok,
    title: 'PIESOK',
    description: 'Piesok je ideálny pre prípravu malty a iných stavebných zmesí vďaka svojej jemnej zrnitosti a konzistencii.',
    link: '/ponuka/piesok',
  },
  {
    img: dekorativne,
    title: 'DEKORATÍVNE',
    description: 'Dekoratívne materiály pridávajú estetickú hodnotu a unikátny vzhľad každému projektu.',
    link: '/ponuka/okrasny',
  },
];

function Home() {
  return (
    <div>
      <Navbar />
      <Hero />
      <WhyUs />

      <div className="py-20 max-w-screen-xl mx-auto px-6">
        <AnimateOnScroll>
          <div className="text-center text-5xl font-bold mb-14 text-gray-800">
            Naša <span className="text-red-600">ponuka</span>
          </div>
        </AnimateOnScroll>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
          {items.map((item, index) => (
            <AnimateOnScroll delay={index * 100}>
              <div className="relative w-full rounded-lg overflow-hidden shadow-xl flex flex-col group cursor-pointer hover:shadow-2xl transition-shadow duration-300">
                <img
                  src={item.img}
                  className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
                  alt={item.title}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-white bg-opacity-75 text-black p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="font-bold text-3xl text-red-600">{item.title}</h3>
                    <p className="text-gray-800 mt-2 text-lg">{item.description}</p>
                  </div>
                  <Link
                    to={item.link}
                    className="mt-4 bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded text-center font-semibold transition-colors duration-200"
                  >
                    Objednaj
                  </Link>
                </div>
              </div>
            </AnimateOnScroll>
          ))}
        </div>
      </div>

      <Contact />
      <Footer />
      <ScrollRestoration />
    </div>
  );
}

export default Home;
